var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_16165",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H0V30H31V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_16165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H8.5C4.08172 0 0.5 3.58172 0.5 8V22C0.5 26.4183 4.08172 30 8.5 30H22.5C26.9183 30 30.5 26.4183 30.5 22V8C30.5 3.58172 26.9183 0 22.5 0Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.5H8.5C4.35786 0.5 1 3.85786 1 8V22C1 26.1421 4.35786 29.5 8.5 29.5H22.5C26.6421 29.5 30 26.1421 30 22V8C30 3.85786 26.6421 0.5 22.5 0.5Z",
    stroke: "white",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9504 23.6471C10.173 22.9956 8.00437 20.827 7.35288 18.0496C6.88237 16.0437 6.88237 13.9563 7.35288 11.9504C8.00437 9.17301 10.173 7.00437 12.9504 6.35288C14.9563 5.88237 17.0437 5.88237 19.0496 6.35288C21.827 7.00437 23.9956 9.17301 24.6471 11.9504C25.1176 13.9563 25.1176 16.0437 24.6471 18.0496C23.9956 20.827 21.827 22.9956 19.0496 23.6471C17.0437 24.1176 14.9563 24.1176 12.9504 23.6471Z",
    fill: "white",
    fillOpacity: 0.05,
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 18.5,
    r: 1,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13V12.5C14 11.3954 14.8954 10.5 16 10.5V10.5V10.5C17.1046 10.5 18 11.3954 18 12.5V12.6213C18 13.1839 17.7765 13.7235 17.3787 14.1213L16 15.5",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.831d4e2663eeae7ed920d66fa817d021.svg";
export { ForwardRef as ReactComponent };